import { useVariableGroups } from "api/variableGroups";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { useManageInfiniteScroll } from "hooks/useManageInfiniteScroll";
import { useState } from "react";

interface Props {
  fieldName: string;
  "data-test-id"?: string;
  label?: string;
  value: string | string[];
  placeholder?: string;
}

export const VariableGroupsDropdown = ({
  fieldName,
  label,
  placeholder,
  value,
  "data-test-id": dataTestId,
}: Props) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { useInfiniteListOfVariableGroups, useVariableGroupDetails } =
    useVariableGroups();
  const { message } = useMessage();

  const {
    data: infiniteVariableGroupsList,
    size: variableGroupsSize,
    setSize: setVariableGroupsSize,
    isValidating,
  } = useInfiniteListOfVariableGroups({
    filters: searchQuery
      ? [
          {
            condition: "like",
            query: "name",
            value: searchQuery,
          },
        ]
      : [],
    sortKey: "name",
    order: "asc",
  });

  const {
    infiniteData: variableGroupsList,
    anyElementsToFetch: anyVarbialeGroupsToFetch,
  } = useManageInfiniteScroll(infiniteVariableGroupsList || []);

  const { data: selectetGroups } = useVariableGroupDetails(value);

  const initialValue =
    selectetGroups &&
    (Array.isArray(selectetGroups)
      ? selectetGroups.map((group) => ({
          id: group.groupOfValuesId,
          label: group.name,
        }))
      : {
          id: selectetGroups.groupOfValuesId,
          label: selectetGroups.name,
        });

  return (
    <SelectInput
      displaySearch
      asyncSearch={(query) => setSearchQuery(query)}
      multiple
      data-test-id={dataTestId}
      width="100%"
      items={
        variableGroupsList.map((group) => ({
          id: group.groupOfValuesId,
          label: group.name,
          labelInfo: `${group.recordsInGroup} ${message({ id: "records" })}`,
        })) || []
      }
      label={label}
      name={fieldName}
      placeholder={placeholder}
      renderAsChips
      chipsType="catalog"
      initialValue={initialValue}
      anyElementsToFetch={anyVarbialeGroupsToFetch}
      loadMoreElements={() =>
        !isValidating && setVariableGroupsSize(variableGroupsSize + 1)
      }
    />
  );
};
